import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-2a307904"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "background"
};
const _hoisted_2 = {
  class: "main"
};
const _hoisted_3 = {
  class: "top-back"
};
const _hoisted_4 = {
  class: "icon-main"
};
const _hoisted_5 = ["src"];

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 小圈约 ");

const _hoisted_7 = {
  class: "mid-back"
};
const _hoisted_8 = {
  class: "left-back"
};
const _hoisted_9 = ["src"];

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mid-title"
}, "真实    ·   真诚    ·   真心", -1));

const _hoisted_11 = {
  class: "btn-back"
};
const _hoisted_12 = {
  class: "btn-backs"
};
const _hoisted_13 = ["src"];

const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Android下载");

const _hoisted_15 = ["src"];

const _hoisted_16 = /*#__PURE__*/_createTextVNode("iOS下载");

const _hoisted_17 = {
  class: "qrback"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  class: "beian-top"
};

const _hoisted_21 = /*#__PURE__*/_createTextVNode("网站备案/许可证号：");

const _hoisted_22 = {
  class: "beian-link",
  target: "_blank",
  href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602011124"
};
const _hoisted_23 = ["src"];

const _hoisted_24 = /*#__PURE__*/_createTextVNode("粤公网安备 44010602011124号");

const _hoisted_25 = /*#__PURE__*/_createTextVNode("   网站备案/许可证号：");

const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "beian-link",
  target: "_blank",
  href: "https://beian.miit.gov.cn/"
}, "粤ICP备2022145697号-1", -1));

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "beian"
}, "违法和不良信息举报邮箱：xqy888vip@163.com", -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_contact_tip = _resolveComponent("contact-tip");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
    src: $setup.quan,
    class: "icon"
  }, null, 8, _hoisted_5), _hoisted_6]), _createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.tips.showTip && $setup.tips.showTip(...args))
  }, "联系我们")]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
    src: $setup.word,
    class: "big-word"
  }, null, 8, _hoisted_9), _hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
    class: "down-btn",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.downloadAndroid && $setup.downloadAndroid(...args))
  }, [_createElementVNode("img", {
    src: $setup.android,
    class: "down-icon"
  }, null, 8, _hoisted_13), _hoisted_14]), _createElementVNode("div", {
    class: "down-btn",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.downIos && $setup.downIos(...args))
  }, [_createElementVNode("img", {
    src: $setup.ios,
    class: "down-icon"
  }, null, 8, _hoisted_15), _hoisted_16])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("img", {
    src: $setup.qrcode,
    class: _normalizeClass({
      'qrcode': true,
      'bigImg': $setup.big
    })
  }, null, 10, _hoisted_18)])])]), _createElementVNode("img", {
    src: $setup.rightimg,
    class: "rightimg"
  }, null, 8, _hoisted_19)]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("a", _hoisted_22, [_createElementVNode("img", {
    class: "beian-img",
    src: $setup.beian
  }, null, 8, _hoisted_23), _hoisted_24]), _hoisted_25, _hoisted_26]), _hoisted_27]), _createVNode(_component_contact_tip, {
    ref: "tips"
  }, null, 512), _withDirectives(_createElementVNode("div", {
    class: "back",
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.bigImg && $setup.bigImg(...args))
  }, null, 512), [[_vShow, $setup.big]]), _withDirectives(_createElementVNode("div", {
    onClick: _cache[4] || (_cache[4] = (...args) => $setup.bigImg && $setup.bigImg(...args)),
    class: "code-title"
  }, "扫描二维码下载", 512), [[_vShow, $setup.big]])]);
}